import { Route } from '@angular/router';

import { localTournamentGamesRoutes } from './games/local-tournament-games.routes';

export const localTournamentRoutes: Route[] = [
    {
        path: 'tournaments/local',
        loadComponent: () =>
            import('./pages/local-tournaments/local-tournaments.component').then((c) => c.LocalTournamentsComponent),
    },
];

export const localTournamentPublicRoutes: Route[] = [
    {
        path: 'tournaments/local/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/local-tournament-view/local-tournament-view.component').then(
                (c) => c.LocalTournamentViewComponent
            ),
    },
    {
        path: 'tournaments/local/:id/:view',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/local-tournament-view/local-tournament-view.component').then(
                (c) => c.LocalTournamentViewComponent
            ),
    },
    ...localTournamentGamesRoutes,
];
